/**
 * How much the scope of work says (PLAN_venueswest A, the 28 Sep meeting): shown, not chosen, at the plan review.
 * The customer's rules set it, `minimal` by default for VenuesWest; changing it is the agent configurator's.
 */
export const LEVELS: Record<string, string> = {
  minimal: "short and to the point: one obligation per sentence, no preamble or restating",
  standard: "complete and specific, without padding",
  full: "with context and rationale where a section calls for it",
};

export function LevelOfDetail({ level, reason }: { level: string; reason?: string | null }) {
  return (
    <div className="style-line level-of-detail" aria-label="Level of detail">
      <span>Level of detail: <strong>{level}</strong>{LEVELS[level] ? <span className="muted"> — {LEVELS[level]}</span> : null}</span>
      <span className="muted small">{reason ? `Why: ${reason}. ` : ""}It is set in the agent configuration, not per request.</span>
    </div>
  );
}
